<fikoyt-kart>
      <button nz-button
              nz-wave
              style="position: absolute;"
              [routerLink]="['/giris']"
              nzType="default"
              nzShape="circle"
              nzSize="small"><nz-icon nzType="home" /></button>
      <img ngSrc="./simgeler/fikoyt_yazi.png"
           alt="Site Logo Yazı"
           height="54"
           width="166"
           style="height: unset; width: 166px; box-shadow: none !important;align-self: center;">

      <fikoyt-yuvarlak-resim (imageUrlChange)="imageChange($event );"></fikoyt-yuvarlak-resim>
      
      <nz-alert nzMessage="Aramıza Katılın"
                style="text-align: center;"></nz-alert>

      <span nz-typography
            nzType="secondary">Adınız :</span>
      <nz-input-wrapper nzPrefix="✏️"
                      nzSize="small">
            <input type="text" autocomplete="given-name" nz-input [(ngModel)]="form.isim" />
      </nz-input-wrapper>

      <span nz-typography
            nzType="secondary">Soy Adınız :</span>
      <nz-input-wrapper nzPrefix="👨‍👩‍👧‍👦"
                      nzSize="small">
            <input type="text" autocomplete="family-name" nz-input  [(ngModel)]="form.soyIsim"/>
      </nz-input-wrapper>

      <span nz-typography
            nzType="secondary">Kullanıcı Adı :</span>
      <nz-input-wrapper nzPrefix="👩🏻‍🤝‍👨🏽"
                      nzSize="small">
            <input type="text" autocomplete="username"  nz-input [(ngModel)]="form.kullaniciAdi"/>
      </nz-input-wrapper>

      <span nz-typography
            nzType="secondary">E-Posta :</span>
      <nz-input-wrapper nzPrefix="📧"
                      nzSize="small">
            <input type="email" autocomplete="email" nz-input [(ngModel)]="form.ePosta"/>
      </nz-input-wrapper>

      <span nz-typography
            nzType="secondary">Parola :</span>
      <nz-input-wrapper nzPrefix="🔑"
                      nzSize="small">
            <input type="password" autocomplete="current-password" nz-input [(ngModel)]="form.parola"/>
      </nz-input-wrapper>

      <span nz-typography
            nzType="secondary">Parola Tekrar :</span>
      <nz-input-wrapper nzPrefix="🔑"
                      nzSize="small">
            <input type="password" autocomplete="new-password" nz-input [(ngModel)]="form.parolaTekrar"/>
      </nz-input-wrapper>

      <label nz-checkbox
             [(ngModel)]="form.anlasma">Anlaşmayı biliyorum onaylıyorum.</label>

      <button nz-button
              nz-wave
              nzSize="small"
              nzType="link"
              style="margin-top: 0.5em;"
              (click)="gonder();"
              >
            📬
            Gönder
      </button>

</fikoyt-kart>